import { formatDate } from "~/utils/formatDate";

export const formatAuthorLine = (
  authorName: string | null | undefined,
  publishedAt: string | null | undefined,
): string =>
  [authorName, publishedAt && formatDate(publishedAt, { dateOnly: true })]
    .filter(Boolean)
    .join(" · ");
